import { render, staticRenderFns } from "./Resolver.vue?vue&type=template&id=497314fc"
import script from "./Resolver.vue?vue&type=script&lang=js"
export * from "./Resolver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports